<template>
  <b-col cols="12" sm="12">
    <div>
      <a class="btnVolver" @click="$router.push({ path: 'marcas' })" title="Cerrar">
        <feather id="btnX" type="arrow-left-circle"></feather>
      </a>
    </div>
    <b-card class="mx-auto" tile>
      <div v-if="!submitted">
        <b-form @submit.stop.prevent="createMarca" style="z-index: 1">
          <b-col cols="12" sm="12">
            <div class="row">
              <b-col cols="12" sm="12">
                <label for="“nombre”">{{ $t('vMarca.marca') }}* :</label>
                <b-form-input id="input-nombre" v-model="marca.nombre" :state="validarMarca"
                  aria-describedby="input-nombre-help input-nombre-feedback" trim></b-form-input>
                <b-form-invalid-feedback id="input-nombre-feedback">
                  {{ $t('vMarca.msgMarca') }}
                </b-form-invalid-feedback>
              </b-col>
            </div>
            <div class="row">
              <div class="col-12 col-sm-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 d-lg-flex justify-content-lg-end">
                <b-btn color="primary" class="ancho-boton w-100" style="color: white" to="/Marcas">
                  {{ this.$t("Gral.cancelar") }}
                </b-btn>
              </div>
              <div class="col-12 col-sm-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 sepracion-div-boton-guardar">
                <b-btn variant="info" class="ancho-boton w-100" style="color: white" type="submit"
                  :disabled="!validarMarca">
                  {{ $t('vMarca.agregarMarca') }}
                </b-btn>
              </div>
            </div>
          </b-col>
        </b-form>
      </div>
    </b-card>
  </b-col>
</template>

<script src="js/main.js"></script>
<script>
import MarcasDataService from "../../../services/MarcasDataService";
import AccionesDataService from "../../../services/AccionesDataService";
import { verificarAcceso } from '../../../utils/Session';

export default {
  name: "add-marca",
  data() {
    return {
      marca: {
        id: 0,
        nombre: "",
        habilitado: true,
      },
      submitted: false,
      accion: "",
      usuarioLogueado: JSON.parse(sessionStorage.getItem("usuarioLogueado")),
      key: "",
    };
  },
  beforeCreate() {
    verificarAcceso();
    if (
      !sessionStorage.getItem("rol") ||
      sessionStorage.idRol === process.env.VUE_APP_ID_USUARIO_FINAL
    ) {
      this.$router.push({
        path: "/monitoreo",
      });
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "error",
        title: this.$t("vDispositivos.noPermisos"),
      });
    }
  },
  mounted(){
    this.key = sessionStorage.getItem('key')
  },
  computed: {
    //Retorna true o false dependiedo si el campo nombre tiene información o no y si el nombre tiene mas de 
    // 3 carácteres 
    validarMarca() {
      return this.marca.nombre.length  >= 3 && this.marca.nombre.trim() !== '' ? true : false;
    },
  },

  methods: {

    async createMarca() {
      try {
        const data = {
          marca: this.marca.nombre,
          habilitado: this.marca.habilitado,
        };

        const response = await  MarcasDataService.create(data, this.key)
        if(response.status === 200){
          this.registrarAccion();
          this.alertSweet('success', this.$t('vMarca.msgRegistro'))
          this.$router.push("/marcas");
        }
      } catch (error) {
        this.alertSweet('error', this.$t('vMarca.msgErrorMarca'))
      }
    },

    registrarAccion() {
      var data = {
        usuario: this.usuarioLogueado,
        accion: this.accion + sessionStorage.infoDevice,
        fechaCreacion: new Date(),
        tipo: "accion",
      };
      AccionesDataService.create(data, this.key);
    },

    alertSweet(icon, message){
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", this.$swal.stopTimer);
        toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: icon,
        title: message
      });
    },
  },
}
</script>

<style>
.myMargin {
  margin-left: 1rem;
}

.submit-form {
  max-width: 400px;
}

@media (max-width: 768px) {
  .btnVolver {
    position: absolute;
    top: -40px;
    left: 16px;
  }
}

@media (min-width: 769px) {
  .btnVolver {
    display: none !important;
  }
}

@media (max-width: 959px) {
  .sepracion-div-boton-guardar {
    margin-top: -12px
  }
}

@media (min-width: 960px) {
  .sepracion-div-boton-guardar {
    margin-top: 0px
  }
}

@media (min-width: 992px) {
  .ancho-boton {
    width: 200px !important;
  }
}
</style>
